import { motion } from "framer-motion";
export const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed h-dvh inset-0 bg-black/30 backdrop-blur-sm z-[4000] flex items-center justify-center"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{
          duration: 0.2,
          stiffness: 400,
          type: "spring",
          damping: 24,
        }}
      >
        {children}
      </motion.div>
    </div>
  );
};
